import { useState } from "react";
import { Printer, ReceiptText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PrintPortal, printNow } from "@/lib/print";

// Renders A4 + 80mm thermal print buttons; children(format) returns printable content
export default function PrintButtons({ children, testPrefix = "print", size = "sm" }) {
  const [format, setFormat] = useState(null);
  const go = (f) => { setFormat(f); printNow(f); };
  return (
    <div className="no-print flex flex-wrap gap-2">
      <Button size={size} variant="outline" className="rounded-full btn-press border-blue-200 text-[#0052FF] hover:bg-blue-50" onClick={() => go("a4")} data-testid={`${testPrefix}-a4-button`}>
        <Printer className="h-4 w-4" /> A4 print
      </Button>
      <Button size={size} variant="outline" className="rounded-full btn-press border-blue-200 text-[#0052FF] hover:bg-blue-50" onClick={() => go("thermal")} data-testid={`${testPrefix}-thermal-button`}>
        <ReceiptText className="h-4 w-4" /> Receipt (80mm)
      </Button>
      {format && <PrintPortal>{children(format)}</PrintPortal>}
    </div>
  );
}
